import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';

import { bibShape, fieldErrorsShape } from '@bibliocommons/bc-prop-types';

import { CONTENT_PROVIDER_IDS, SEARCH_FACET_FIELD_ID } from 'app/constants/BibConstants';
import { FORMAT_ID } from 'app/constants/displayBib';
import { CHAT_WIDGET_ID } from 'app/constants/LibraryConstants';

export const filterShape = ImmutablePropTypes.mapContains({
  applied: PropTypes.bool.isRequired,
  count: PropTypes.number.isRequired,
  groupIds: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  label: PropTypes.string,
  value: PropTypes.string
});

export const activeFiltersShape = ImmutablePropTypes.mapOf(
  ImmutablePropTypes.listOf(filterShape),
  PropTypes.oneOf(Object.values(SEARCH_FACET_FIELD_ID))
);

export const branchShape = ImmutablePropTypes.mapContains({
  code: PropTypes.string.isRequired,
  ips: ImmutablePropTypes.listOf(PropTypes.string).isRequired,
  name: PropTypes.string.isRequired
});

export const catalogSearchOptionsShape = ImmutablePropTypes.mapContains({
  showGroupings: PropTypes.bool.isRequired
});

export const chatWidgetsShape = ImmutablePropTypes.mapContains({
  [CHAT_WIDGET_ID.LIB_ANSWERS]: ImmutablePropTypes.mapContains({
    enabled: PropTypes.bool.isRequired
  }).isRequired,
  [CHAT_WIDGET_ID.LIBRARY_H3LP]: ImmutablePropTypes.mapContains({
    enabled: PropTypes.bool.isRequired
  }).isRequired,
  [CHAT_WIDGET_ID.MOSIO]: ImmutablePropTypes.mapContains({
    enabled: PropTypes.bool.isRequired
  }).isRequired,
  [CHAT_WIDGET_ID.REF_CHATTER]: ImmutablePropTypes.mapContains({
    enabled: PropTypes.bool.isRequired
  }).isRequired,
  [CHAT_WIDGET_ID.Q_WIDGET]: ImmutablePropTypes.mapContains({
    enabled: PropTypes.bool.isRequired
  }).isRequired,
  [CHAT_WIDGET_ID.UNIQUE_CHAT]: ImmutablePropTypes.mapContains({
    enabled: PropTypes.bool.isRequired
  }).isRequired
});

export const drawerShape = ImmutablePropTypes.mapContains({
  open: PropTypes.bool.isRequired
});

export const fieldsShape = ImmutablePropTypes.listOf(
  ImmutablePropTypes.mapContains({
    fieldFilters: ImmutablePropTypes.listOf(filterShape).isRequired,
    hasMore: PropTypes.bool.isRequired,
    id: PropTypes.oneOf(Object.values(SEARCH_FACET_FIELD_ID)).isRequired,
    value: PropTypes.string
  })
);

export const orderedSearchTypesShape = ImmutablePropTypes.listOf(
  PropTypes.oneOf(['author', 'bkw', 'series', 'smart', 'subject', 'tag', 'title', 'user', 'userlist'])
);

export const recommendationShape = PropTypes.exact({
  availableCopies: PropTypes.number.isRequired,
  format: PropTypes.oneOf(Object.values(FORMAT_ID)).isRequired,
  id: PropTypes.string.isRequired,
  jacket: PropTypes.exact({
    small: PropTypes.string.isRequired,
    large: PropTypes.string.isRequired,
    local_url: PropTypes.string,
    medium: PropTypes.string.isRequired,
    type: PropTypes.oneOf(Object.values(CONTENT_PROVIDER_IDS)).isRequired
  }).isRequired,
  title: PropTypes.string.isRequired
});

export const scopeShape = ImmutablePropTypes.contains({
  scopeName: PropTypes.string.isRequired,
  scopeId: PropTypes.string.isRequired,
  parentScopeId: PropTypes.string
});

export const searchResultShape = PropTypes.exact({
  manifestations: ImmutablePropTypes.listOf(bibShape).isRequired,
  representative: bibShape.isRequired
});

export const searchPrintResultsShape = ImmutablePropTypes.listOf(
  ImmutablePropTypes.mapContains({
    title: PropTypes.string.isRequired,
    authors: ImmutablePropTypes.listOf(PropTypes.string),
    format: PropTypes.string.isRequired,
    multiscriptTitle: PropTypes.string,
    subtitle: PropTypes.string,
    multiscriptAuthor: PropTypes.string,
    callNumber: PropTypes.string.isRequired
  })
);

export const searchTypeShape = PropTypes.oneOf([
  'author',
  'bkw',
  'groupkey',
  'keyword',
  'series',
  'smart',
  'subject',
  'tag',
  'title'
]);

export const shelfNameShape = PropTypes.oneOf(['completed', 'for_later', 'in_progress']);

export const sortBysShape = ImmutablePropTypes.listOf(
  ImmutablePropTypes.mapContains({
    applied: PropTypes.bool.isRequired,
    id: PropTypes.oneOf([
      'amount',
      'author',
      'bibTitle',
      'checkedOutDate',
      'date_added',
      'description',
      'dueDate',
      'expiryDate',
      'format',
      'holdPlacedDate',
      'holdsPosition',
      'messageDate',
      'newly_acquired',
      'pickupByDate',
      'pickupLocation',
      'published_date',
      'rating',
      'relevancy',
      'returnedDate',
      'series',
      'status',
      'suspendEndDate',
      'title',
      'ugc_rating'
    ]).isRequired
  })
);
export const savedSearchShape = ImmutablePropTypes.mapContains({
  fieldErrors: fieldErrorsShape,
  isSaving: PropTypes.bool,
  lastNameAttempt: PropTypes.string,
  isDuplicate: PropTypes.bool
});

export const searchProbeShape = PropTypes.shape({
  siteId: PropTypes.string.isRequired,
  libraryName: PropTypes.string.isRequired,
  count: PropTypes.number,
  searchUrl: PropTypes.string.isRequired
});
